import { types, applySnapshot } from 'mobx-state-tree';
import { Transport } from 'modules/common/models/transport';
import { Notificator } from 'modules/common/models/notificator';
import { apiUrls } from 'modules/common/services/communication/urls';
import { flow } from 'modules/common/models/flow';
import { ClientDictionaryItem, ClientDictionaryItemType } from './client';

export const ClientDictionary = types.compose(
    Transport, Notificator, types.model({
        clients: types.array(ClientDictionaryItem),
    }))
    .actions((self) => ({
        load: flow(function* (){
            try {
                const data: ClientDictionaryItemType[] = yield self.transport.get<any>(apiUrls.clients.dictionary());
                applySnapshot(self.clients, data);

                return true;
            } catch (er) {
                self.notify.error(er);
                return false;
            }
        })
    }))
    .views((self) => ({
        get isEmpty () {
            return !self.clients.length;
        }
    }))
    .named('ClientDictionary');

export const initialState = (): ClientDictionarySnapshotType => ({
    clients: []
});

export type ClientDictionaryType = typeof ClientDictionary.Type;
export type ClientDictionarySnapshotType = typeof ClientDictionary.SnapshotType;
